var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"slide"}},[(_vm.currentMessage)?_c('div',{key:_vm.currentMessage.id,staticClass:"toast",class:_vm.currentMessage.type},[_c('div',{ref:"timer",staticClass:"timer"}),_c('div',{staticClass:"text"},[_vm._v(_vm._s(_vm.currentMessage.message))])]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }